import { Dep0306CtlrIn, Dep0306CtlrOut } from 'app/core/models/api/dep/dep0306'
import { Crd0102CtlrOut, Crd0102CtlrIn } from 'app/core/models/api/crd/crd0102'
import { api } from 'app/core/services/base/api.service'
import { CommonResponse } from 'app/core/services/base/response.service'
import { Crd0101CtlrIn, Crd0101CtlrOut } from 'app/core/models/api/crd/crd0101'
import { Crd0103CtlrIn, Crd0103CtlrOut } from 'app/core/models/api/crd/crd0103'
import { Crd0104CtlrIn, Crd0104CtlrOut } from 'app/core/models/api/crd/crd0104'
import { Crd0106CtlrIn, Crd0106CtlrOut } from 'app/core/models/api/crd/crd0106'
import { Dep0401CtlrOut, Dep0401CtlrIn } from 'app/core/models/api/dep/dep0401'

import {
    Com0102CtlrIn,
    Com0102CtlTrnOut,
} from 'app/core/models/api/com/com0102'
import { Crd0201CtlrOut, Crd0201CtlrIn } from 'app/core/models/api/crd/crd0201'
import { Crd0204CtlrOut } from 'app/core/models/api/crd/crd0204'

let suffixPath = 'prd/dep'
let suffixPath1 = 'prd/crd'
let suffixPath2 = 'prd/com'

export const postApi = api.injectEndpoints({
    endpoints: (build) => ({
        // 카드상세조회
        selectDep0306: build.query<Dep0306CtlrOut, Dep0306CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/dep03/dep0306`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Dep0306CtlrOut>,
        }),

        // 비대면 체크카드 발급
        exeCrd0101: build.query<Crd0101CtlrOut, Crd0101CtlrIn>({
            query: (body) => ({
                url: `${suffixPath1}/crd01/crd0101`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Crd0101CtlrOut>,
        }),

        // 카드상품가입 선조회 (dep0306 상품상세정보와 crd0103 비대면 카드발급 고객정보조회 )
        selectCrd0102: build.query<Crd0102CtlrOut, Crd0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath1}/crd01/crd0102`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Crd0102CtlrOut>,
        }),

        // 비대면 카드발급 고객정보조회
        selectCrd0103: build.query<Crd0103CtlrOut, Crd0103CtlrIn>({
            query: (body) => ({
                url: `${suffixPath1}/crd01/crd0103`,
                method: 'POST',
                body,
            }),

            transformResponse: CommonResponse<Crd0103CtlrOut>,
            extraOptions: { handleLocally: true },
        }),

        // ISIC고객확인번호 조회
        selectCrd0104: build.query<Crd0104CtlrOut, Crd0104CtlrIn>({
            query: (body) => ({
                url: `${suffixPath1}/crd01/crd0104`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Crd0104CtlrOut>,
        }),

		// 항공사회원번호 유효성검증
		selectCrd0106: build.query<Crd0106CtlrOut, Crd0106CtlrIn>({
		    query: (body) => ({
		        url: `${suffixPath1}/crd01/crd0106`,
		        method: 'POST',
		        body,
		    }),
		    transformResponse: CommonResponse<Crd0106CtlrOut>,
		}),
		
        /**
         * 상품별거래제어
         */
        selectCom0102: build.query<Com0102CtlTrnOut, Com0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath2}/com01/com0102`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0102CtlTrnOut>,
        }),
        // 군인공제회고객 조회
        selectDep0401: build.query<Dep0401CtlrOut, Dep0401CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/dep04/dep0401`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Dep0401CtlrOut>,
            extraOptions: { handleLocally: true },
        }),
        // 카드상품가입 선조회 (dep0306 상품상세정보와 crd0103 비대면 카드발급 고객정보조회 )
        selectCrd0102Re: build.query<Crd0102CtlrOut, Crd0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath1}/crd01/crd0102`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Crd0102CtlrOut>,
            extraOptions: { handleLocally: true },
        }),
        // 나라사랑포탈 검증
        selectCrd0201: build.query<Crd0201CtlrOut, Crd0201CtlrIn>({
            query: (body) => ({
                url: `${suffixPath1}/crd02/crd0201`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Crd0201CtlrOut>,
        }),
        // 네이버ID 조회
        selectCrd0204: build.query<Crd0204CtlrOut, {}>({
            query: (body) => ({
                url: `${suffixPath1}/crd02/crd0204`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Crd0204CtlrOut>,
        }),
    }),
})

export const {
    useLazySelectDep0306Query,
    useLazyExeCrd0101Query,
    useLazySelectCrd0102Query,
    useLazySelectCrd0103Query,
    useLazySelectCrd0104Query,
	useLazySelectCrd0106Query,
    useLazySelectCom0102Query,
    useLazySelectDep0401Query,
    useLazySelectCrd0102ReQuery,
    useLazySelectCrd0201Query,
    useLazySelectCrd0204Query,
} = postApi

export const {
    endpoints: {
        selectDep0306,
        exeCrd0101,
        selectCrd0102,
        selectCrd0103,
        selectCrd0104,
		selectCrd0106,
        selectCom0102,
        selectDep0401,
        selectCrd0102Re,
        selectCrd0201,
        selectCrd0204,
    },
} = postApi
